<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">{{ field }} Usage Stats</modal-header>
        </div>
      <chart :options="tableData()"/>

      <div class="clients">
        <div class="pageContent">
          <Spinner v-if="loading"/>
          <form-group>
            <input :max="new Date().toISOString().slice(0, 10)" title="Start Date" v-model="form.from" @change="callApi" type="date" :style="{maxWidth: '40%', marginBottom: '1rem'}" class="form-control col-md-5 mr-sm-2" />
          </form-group>
          <form-group>
            <input :max="new Date().toISOString().slice(0, 10)" title="End Date" v-model="form.to" @change="callApi" type="date" :style="{maxWidth: '40%', marginBottom: '1rem', marginLeft: '1rem', float: 'right'}" class="form-control col-md-5 mr-sm-2" />
          </form-group>
          <form-group :style="{maxWidth: '100%', marginBottom: '1rem', marginLeft: '1rem'}">
            <select title="Month" v-model="form.month" @change="setDateAndCallApi" class="form-control col-md-5 mr-sm-2" >
              <option :value="0">Select Month</option>
              <option v-for="(month, idx) in generateMonths()" :value="idx + 1" :key="idx">{{ month }}</option>
            </select>
          </form-group>
        </div>
      </div>
        <div slot="modalFooter">
          <modal-footer :back="close" :showBack="true" :hideConfirmText="true" :hideCancelText="true"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {notificationMixin} from '@/mixins/notificationMixin'
import {clientMixin} from '@/mixins/clientMixin'
import {modalMixin} from '@/mixins/modalMixin'
import Spinner from '@/components/SpinnerIcon/spinner.vue'
import {Chart} from 'highcharts-vue'
import FormGroup from '@/components/Form/FormGroup/form-group.vue'
export default {
  name: 'modal_client_confirm',
  mixins: [clientMixin, notificationMixin, modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    Spinner,
    Chart,
    FormGroup
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({
    columns: {
      tier: 'Tier',
      download_counter: 'Downloads Count',
      renders_counter: 'Renders Count',
      adtag_create_counter: 'Ad Tag Create Count',
      adtag_refresh_counter: 'Ad Tag Refresh Count'
    },
    form: {
      to: new Date().toISOString().slice(0, 10),
      from: '',
      month: 0,
      id: undefined
    }
  }),
  watch: {
    show () {
      if (this.show) {
        this.form.id = this.confirmId
        this.callApi()
      }
    }
  },
  computed: {},
  methods: {
    generateMonths () {
      const currentDate = new Date()
      const months = []
      for (let i = 0; i <= currentDate.getMonth(); i++) {
        const date = new Date(currentDate.getFullYear(), i, 1)
        months[i] = date.toLocaleString('default', { month: 'long' })
      }
      return months
    },
    confirm () {
      this.startLoading()
      this.deleteClient(this.confirmId).then(() => {
        this.getClients().then(() => {
          this.finishLoading()
          this.addNotification('success', `Client deleted.`)
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    },
    callApi () {
      this.startLoading()
      this.getClientStats(this.form).then(() => {
        this.finishLoading()
      })
    },
    setDateAndCallApi () {
      if (this.form.month) {
        let from = new Date()
        let to = new Date()
        from.setMonth(this.form.month - 1)
        from.setDate(1)
        to.setMonth(this.form.month)
        to.setDate(0)
        if (to > new Date()) {
          to = new Date()
        }
        this.form.to = to.toISOString().slice(0, 10)
        this.form.from = from.toISOString().slice(0, 10)
      }
      this.callApi()
    },
    tableData () {
      if (!this.stats) {
        return {}
      }
      document.querySelectorAll('.highcharts-credits').forEach(e => e.remove())
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Client Usage Stats'
        },
        xAxis: {
          categories: [
            'Downloads Count',
            'Renders Count',
            'Ad Tag Create Count',
            'Ad Tag Refresh Count'
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Count Value'
          }
        },
        tooltip: {
          headerFormat: `<span style='font-size:10px'>{point.key}</span><table>`,
          pointFormat: `<tr><td style='color:{series.color};padding:0'>{series.name}: </td>` +
              `<td style='padding:0'><b>{point.y}</b></td></tr>`,
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.05,
            borderWidth: 0
          }
        },
        series: [{
          name: 'Tier 1',
          color: '#435589',
          data: [
            this.stats.stats.t1_download_count,
            this.stats.stats.t1_render_count,
            this.stats.stats.t1_ad_tag_create_count,
            this.stats.stats.t1_ad_tag_refresh_count
          ]
        }, {
          name: 'Tier 2',
          color: '#56ffa2',
          data: [
            this.stats.stats.t2_download_count,
            this.stats.stats.t2_render_count,
            this.stats.stats.t2_ad_tag_create_count,
            this.stats.stats.t2_ad_tag_refresh_count
          ]
        }]
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/clients/modal-client-stats.vue